(() => {
  const normalize = (value) => (value || '').toLowerCase().replace(/\s+/g, ' ').trim();

  function initResourcePage(root) {
    const search = root.querySelector('[data-fr-search]');
    const items = [...root.querySelectorAll('[data-fr-search-item]')];
    const empty = root.querySelector('[data-fr-empty]');
    const count = root.querySelector('[data-fr-result-count]');
    const categoryButtons = [...root.querySelectorAll('[data-fr-category]')];
    const categoryRadios = [...root.querySelectorAll('input[name="fr-manual-category"]')];
    const clear = root.querySelector('[data-fr-clear]');
    let activeCategory = 'all';

    function applyFilters() {
      const query = normalize(search ? search.value : '');
      let visibleCount = 0;
      items.forEach((item) => {
        const matchesSearch = !query || normalize(item.dataset.frSearchText || item.textContent).includes(query);
        const matchesCategory = activeCategory === 'all' || item.dataset.frCategoryName === activeCategory;
        const visible = matchesSearch && matchesCategory;
        item.hidden = !visible;
        if (visible) visibleCount += 1;
      });

      root.querySelectorAll('.fr-faq-group').forEach((group) => {
        group.hidden = !group.querySelector('[data-fr-search-item]:not([hidden])');
      });
      if (empty) empty.hidden = visibleCount !== 0;
      if (count) count.textContent = `${visibleCount} result${visibleCount === 1 ? '' : 's'}`;
    }

    function setCategory(category) {
      activeCategory = category || 'all';
      categoryButtons.forEach((button) => button.classList.toggle('is-active', button.dataset.frCategory === activeCategory));
      categoryRadios.forEach((radio) => { radio.checked = radio.value === activeCategory; });
      applyFilters();
    }

    if (search) search.addEventListener('input', applyFilters);
    categoryButtons.forEach((button) => button.addEventListener('click', () => setCategory(button.dataset.frCategory)));
    categoryRadios.forEach((radio) => radio.addEventListener('change', () => setCategory(radio.value)));
    if (clear) clear.addEventListener('click', () => {
      if (search) search.value = '';
      setCategory('all');
      if (search) search.focus();
    });
    applyFilters();
  }

  document.querySelectorAll('[data-fr-resource-page]').forEach(initResourcePage);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-fr-resource-page]').forEach(initResourcePage);
  });
  function initPolicyPage(root) {
    const slugify = (value) => normalize(value)
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '');

    root.querySelectorAll('.fr-policy-content h1, .fr-policy-content h2, .fr-policy-content h3, .fr-policy-content p > strong:first-child').forEach((heading) => {
      const target = heading.matches('strong') ? heading.parentElement : heading;
      const id = slugify(heading.textContent);
      if (id && target && !target.id) target.id = id;
    });

  }

  document.querySelectorAll('[data-fr-policy-page]').forEach(initPolicyPage);
})();
